import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import React, { useCallback, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import ItemListView from "app/components/ItemListView";
import ReportListItemWithDates from "./ReportListItemWithDates";
import UtilizationReportListItem from "./UtilizationReportListItem";
import { useTranslation } from "react-i18next";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";
import ReportListItemWithCoach from "./ReportListItemWithCoach";
import { cls } from "app/utils";

const HistoryModal = ({ onClose, report, isOpen }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const callback = useCallback(
    (list, setVariables) => {
      const { pageNumber } = list;

      schedulingFetchGet<any[]>(`generated_reports`, {
        page: pageNumber,
        per_page: 20,
        report_id: report.id,
      })
        .then((response) => {
          setVariables({ items: response });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    [report?.id],
  );

  const list = useMemo(() => {
    const emptyListItem = () => (
      <span className={styles.empty_list}>
        {t("There are no reports to display")}
      </span>
    );

    if (
      report?.id === "coach_activity_by_session" ||
      report?.id === "coach_activity_by_athlete" ||
      report?.id === "coach_activity_by_program" ||
      report?.id === "coach_transactions" ||
      report?.id === "coach_packages" ||
      report?.id === "coach_subscriptions"
    ) {
      return (
        <ItemListView
          Item={ReportListItemWithDates}
          callback={callback}
          NoItemsView={emptyListItem}
          loading={loading}
          setLoading={setLoading}
        />
      );
    } else if (
      report?.id === "coach_utilization" ||
      report?.id === "facility_utilization"
    ) {
      return (
        <ItemListView
          Item={UtilizationReportListItem}
          callback={callback}
          NoItemsView={emptyListItem}
          loading={loading}
          setLoading={setLoading}
        />
      );
    } else if (
      report?.id === "facility_activity_by_athlete" ||
      report?.id === "facility_activity_by_coach" ||
      report?.id === "facility_activity_by_program" ||
      report?.id === "facility_activity_by_session" ||
      report?.id === "facility_transactions" ||
      report?.id === "facility_packages" ||
      report?.id === "facility_subscriptions"
    ) {
      return (
        <ItemListView
          Item={ReportListItemWithCoach}
          callback={callback}
          NoItemsView={emptyListItem}
          loading={loading}
          setLoading={setLoading}
        />
      );
    }

    return null;
  }, [callback, loading, report]);

  let column_names;
  let modal_width: string;

  if (
    report?.id === "coach_activity_by_session" ||
    report?.id === "coach_activity_by_athlete" ||
    report?.id === "coach_activity_by_program" ||
    report?.id === "coach_transactions" ||
    report?.id === "coach_packages" ||
    report?.id === "coach_subscriptions"
  ) {
    column_names = (
      <div className={styles.column_header_container}>
        <div>{t("Downloaded On")}</div>
        <div>{t("Format")}</div>
        <div className={styles.width_30px}>{t("Period")}</div>
      </div>
    );
    modal_width = styles.small_width;
  } else if (
    report?.id === "coach_utilization" ||
    report?.id === "facility_utilization"
  ) {
    column_names = (
      <div
        className={cls(styles.column_header_container, styles.grid_five_items)}
      >
        <div className={styles.width_21px}>{t("Downloaded On")}</div>
        <div className={styles.width_8px}>{t("Format")}</div>
        <div>{t("Period")}</div>
        <div>{t("Comparison Period")}</div>
      </div>
    );
    modal_width = styles.large_width;
  } else if (
    report?.id === "facility_activity_by_athlete" ||
    report?.id === "facility_activity_by_coach" ||
    report?.id === "facility_activity_by_program" ||
    report?.id === "facility_activity_by_session" ||
    report?.id === "facility_transactions" ||
    report?.id === "facility_packages" ||
    report?.id === "facility_subscriptions"
  ) {
    column_names = (
      <div
        className={cls(styles.column_header_container, styles.grid_five_items)}
      >
        <div>{t("Downloaded On")}</div>
        <div>{t("Format")}</div>
        <div>{t("Period")}</div>
        <span>{t("Coach Name")}</span>
      </div>
    );
    modal_width = styles.large_width;
  }

  return (
    <ModalLayout
      isOpen={isOpen}
      classNames={`${styles.modal_container} ${modal_width}`}
    >
      <div className={styles.modal_content}>
        <div className={styles.title}>
          <h2>{t(`${report?.title} Report History`)}</h2>
          <div className={styles.close_button} onClick={onClose}>
            <i className="ico ico-x" />
          </div>
        </div>
        <div className={styles.content}>
          {column_names}
          {list}
        </div>
      </div>
    </ModalLayout>
  );
};

export default HistoryModal;
